import { useEffect } from 'react';
import { AppShell } from './components/AppShell';
import { Loading } from './components/Async';
import { LoginScreen } from './auth/LoginScreen';
import { useSession } from './auth/SessionContext';
import { matchRoute, useRouter } from './lib/router';
import { DealPage } from './pages/Deal';
import { DealsPage } from './pages/Deals';
import { EventsPageView } from './pages/Events';
import { EntryPage } from './pages/Entry';
import { HelpPage } from './pages/Help';
import { ClosedLoansPage } from './pages/ClosedLoans';
import { LoansPage } from './pages/Loans';
import { LocationsPage } from './pages/Locations';
import { MarkPage } from './pages/Mark';
import { OverviewPage } from './pages/Overview';

function NotFound() {
  return (
    <main className="page">
      <h1>Az oldal nem található</h1>
      <div className="muted">Ez az útvonal nem létezik. Használd a fenti menüt.</div>
    </main>
  );
}

function Routes() {
  const { pathname, navigate } = useRouter();
  const route = matchRoute(pathname);
  useEffect(() => {
    if (route.name === 'redirect') navigate(route.to, { replace: true });
  }, [route, navigate]);
  switch (route.name) {
    case 'overview': return <OverviewPage />;
    case 'mark': return <MarkPage />;
    case 'deals': return <DealsPage />;
    case 'deal': return <DealPage key={route.id} id={route.id} />;
    case 'entry': return <EntryPage />;
    case 'loans': return <LoansPage />;
    case 'closedloans': return <ClosedLoansPage />;
    case 'events': return <EventsPageView />;
    case 'locations': return <LocationsPage />;
    case 'help': return <HelpPage />;
    case 'redirect': return null;
    case 'notfound': return <NotFound />;
  }
}

export function App() {
  const { state } = useSession();
  if (state.status === 'unknown') {
    return (
      <main className="page">
        <Loading label="Bejelentkezés ellenőrzése…" />
      </main>
    );
  }
  if (state.status === 'unauthenticated') return <LoginScreen kind="unauthenticated" loginError={state.loginError} />;
  if (state.status === 'loggedout') return <LoginScreen kind="loggedout" />;
  if (state.status === 'error') return <LoginScreen kind="error" message={state.message} />;
  return (
    <AppShell>
      <Routes />
    </AppShell>
  );
}
